'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = require('preact');

var _preactFela = require('preact-fela');

var rule = function rule() {
  return {
    height: '24px',
    width: '1px',
    background: 'rgba(255,255,255,0.3)',
    display: 'inline-block'
  };
};

exports.default = (0, _preactFela.createComponent)(rule, 'span');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Core/Dividir.js
// module id = 55
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38